import {
  AfterViewInit,
  Component,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from "@angular/core";
import { AppService } from "src/_services/app.service";
import { Router, ActivatedRoute } from "@angular/router";
import * as moment from "moment";
import { roleTypeOperator, roleTypeSap } from "src/_constants/roleType";
import { MatSort, MatTableDataSource } from "@angular/material";

@Component({
  selector: "app-catalogue-events",
  templateUrl: "./catalogue-events.component.html",
  styleUrls: ["../events-settlements/events-settlements.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class CatalogueEventsComponent implements OnInit, AfterViewInit {
  @ViewChild(MatSort) sort: MatSort;
  public userInfo: any = JSON.parse(sessionStorage.getItem("currentUser"));

  public ForOP = roleTypeOperator.includes(this.userInfo.role);
  public ForSAP = roleTypeSap.includes(this.userInfo.role);
  providers: any = [];
  ProviderId: string = "";
  sportsList = [];
  eventsList = new MatTableDataSource<any>();
  searchKey = "";
  sportId;
  sportName: string = "";
  limit = 0;
  tabIndex;

  eventsTableColumns = ["Open Date", "EventId", "Event Name"];
  constructor(
    private appService: AppService,
    private router: Router,
    private activetedRoute: ActivatedRoute
  ) { }

  ngOnInit() {
    this.activetedRoute.queryParams.subscribe((params) => {
      this.ProviderId = params["providerId"];
      this.sportId = params["sportId"];
      this.sportName = params["sportName"];
    });
    if (this.ProviderId && this.sportId) {
      this.getOurProviders();
      if (this.ProviderId) {
        this.getSportsByProvider(this.ProviderId);
      }
    } else {
      this.getOurProviders();
      if (this.ProviderId) {
        this.getSportsByProvider(this.ProviderId);
      }
    }
    if (this.ProviderId && this.sportId) {
      this.limit = 2;
      this.getEvents();
    }
  }

  ngAfterViewInit() {
    this.eventsList.sort = this.sort;
    this.eventsList.sortingDataAccessor = (item, property) => {
      switch (property) {
        case "Event Name":
          return item.eventName;
        case "Open Date":
          return item.openDate;
        case "EventId":
          return item.eventId;
        default:
          return item[property];
      }
    };
  }

  onSelectedStatusTab(selectedProvider) {
    if (this.limit < 1) {
      this.eventsList.data = [];
      this.ProviderId = selectedProvider;
      this.sportId = "";
      this.getSportsByProvider(this.ProviderId);
    } else if (this.limit === 3) {
      this.limit = 0;
    } else {
      const index = this.providers.findIndex(
        (provider) => provider.ProviderId === this.ProviderId
      );
      this.tabIndex = index;
      this.limit = 3;
      if (this.tabIndex === 0) {
        this.limit = 0;
      }
    }
  }

  getOurProviders() {
    try {
      this.appService.getOurProviders().subscribe((res) => {
        if (res.status === "RS_OK") {
          this.providers = res.providers;
        } else {
          if (res.errorDescription === "Invalid Token!") {
            sessionStorage.clear();
            this.router.navigateByUrl("/login");
          }
        }
      });
    } catch (err) { }
  }

  onSelectedSportName(Sport) {
    this.eventsList.data = [];
    this.sportId = Sport.SportId;
    this.sportName = Sport.SportName;
    this.getEvents();
  }

  getSportsByProvider(providerId) {
    try {
      this.appService.getSportData(providerId).subscribe((res) => {
        if (res.status === "RS_OK") {
          this.sportsList = res.sports;
        } else {
          if (res.errorDescription === "Invalid Token!") {
            sessionStorage.clear();
            this.router.navigateByUrl("/login");
          }
        }
      });
    } catch (err) { }
  }

  searchHandlerChange() {
    this.eventsList.filter = this.searchKey;
  }

  getEvents() {
    try {
      let filters = {
        providerId: this.ProviderId,
        sportId: this.sportId,
      };
      this.appService.getPremiumEvents(filters).subscribe((response) => {
        if (response.status === "RS_OK") {
          this.eventsList.data = response.events.sort(
            (a, b) => b.openDate - a.openDate
          );
        } else {
          this.appService.openErrorBar(response.errorDescription);
        }
      });
    } catch (err) {
      console.log(err);
    }
  }

  goToMarketsPage(event) {
    this.router.navigate(["catalog/catalog-markets"], {
      queryParams: {
        providerId: this.ProviderId,
        sportId: this.sportId,
        eventId: event.eventId,
        eventName: event.eventName,
        sportName: this.sportName,
        openDate: event.openDate,
      },
    });
  }

  convertDate(date) {
    return moment(date).format("DD MMM YYYY hh:mm:ss A");
  }
}
